import React, { useEffect, useState, useRef } from 'react';
import { useTheme } from '@emotion/react';

import { Box, Card, CardContent, CardMedia, Stack, Typography } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import introBg from '../assets/images/intro_bg.svg';
import introBgBttm from '../assets/images/intro_bg_bttm.svg';
import appStoreIcon from '../assets/images/appstore_icon.png';
import playStoreIcon from '../assets/images/playstore_icon.png';
import iphone13 from '../assets/images/iPhone_13.png';
import customerCare from '../assets/images/customer_care.png';
import bookHotel from '../assets/images/book_hotel.png';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import RecentTweets from '../components/tweets/RecentTweets';
import RecentBlogs from '../components/blog/RecentBlogs';
import AppDownloadBtn from '../components/buttons/AppDownloadBtn';
import MoreInfoCard from '../components/cards/MoreInfoCard';
import FAQs from '../components/FAQs';
import { getTweets } from '../features/getTweets';
import { getBlogs } from '../features/getBlogs';
import NavBar from '../components/navigations/NavBar';

const Home = () => {
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [carouselItem, setCarouselItem] = useState('customerCare');
    const isMounted = useRef(false);

    const toggleCarouselItem = () => {
        return setInterval(() => {
            if (isMounted.current) {
                setCarouselItem(prevValue => prevValue === 'customerCare' ? 'bookHotel' : 'customerCare');
            }
        }, 5000);
    }

    useEffect(() => {
        isMounted.current = true;
        const intervalId = toggleCarouselItem();

        return () => {
            clearInterval(intervalId);
            isMounted.current = false;
        };
    }, []);

    return (
        <Box id='#' className='relative'
            data-aos="fade-zoom-in"
            data-aos-easing="linear"
            data-aos-duration="1500"
        >
            <NavBar />
            <Box sx={{ position: 'relative' }}>
                <img src={introBg} alt='' />
                <Box sx={{ position: 'absolute', bottom: '-8px' }}>
                    <img src={introBgBttm} alt='' />
                </Box>
            </Box>

            <Box className='pt-4 flex flex-col items-center text-xl'>
                <Tabs value={value} onChange={handleChange} centered>
                    <Tab label="Vendors" sx={{ color: 'primary.yorisWhite' }} />
                    <Tab label="Customer" sx={{ color: 'primary.yorisWhite' }} />
                    <Tab label="Riders" sx={{ color: 'primary.yorisWhite' }} />
                </Tabs>
                <Box className='w-full mt-8 md:mt-10 flex flex-col items-center'>
                    <Box className='w-full max-w-md'>
                        <Typography component='h3' className='uppercase flex justify-center'>Download On</Typography>
                        <Stack
                            direction='row' gap={4} p={2} justifyContent='center' width='100%'
                        >
                            <AppDownloadBtn img={playStoreIcon} text='Play Store' />
                            <AppDownloadBtn img={appStoreIcon} text='App Store' />
                        </Stack>
                    </Box>
                </Box>

                <Box className='py-5 flex justify-center'
                >
                    <div className='w-full px-3 max-w-[150px] md:max-w-[300px] max-h-[600px]' >
                        <img src={iphone13} alt='iphone13' className='h-full w-full' />
                    </div>
                </Box>

                <Box className='max-w-6xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-center px-5 py-3 md:px-8 pt-10 pb-4 gap-6 md:gap-8 lg:gap-12'>
                    <MoreInfoCard
                        header='Join the conversation'
                        body={`
                            Love to Puddle? Stay up to date on our social
                            media section of the app as you get updates from
                            brands and individuals concerning their product.
                        `}
                        img='https://images.pexels.com/photos/1415734/pexels-photo-1415734.jpeg?auto=compress&cs=tinysrgb&w=600'
                        link=''
                    />
                    <MoreInfoCard
                        header='Book an Event'
                        body={`
                            Love to Puddle? Stay up to date on our social
                            media section of the app as you get updates from
                            brands and individuals concerning their product.
                        `}
                        img='https://images.pexels.com/photos/1566909/pexels-photo-1566909.jpeg?auto=compress&cs=tinysrgb&w=600'
                        link=''
                    />
                    <MoreInfoCard
                        header='An Africa Store'
                        body={`
                            Love to Puddle? Stay up to date on our social
                            media section of the app as you get updates from
                            brands and individuals concerning their product.
                        `}
                        img='https://images.pexels.com/photos/1090972/pexels-photo-1090972.jpeg?auto=compress&cs=tinysrgb&w=600'
                        link=''
                    />
                </Box>

                <Box className='max-w-6xl flex flex-col lg:flex-row justify-center px-5 py-3 md:px-8 pt-12 pb-4'>
                    <Card
                        sx={{
                            backgroundColor: 'primary.light', padding: '25px',
                            width: '100%'
                        }}
                    >
                        <CardMedia className='flex items-center w-full'>
                            {/*<Carousel />*/}
                            {
                                carouselItem === 'customerCare' &&
                                <div
                                    data-aos="fade-zoom-in"
                                    data-aos-easing="linear"
                                    data-aos-duration="2000"
                                    className='max-w-2xl'
                                >
                                    <img src={customerCare} alt='customerCare' />
                                </div>
                            }
                            {   
                                carouselItem === 'bookHotel' &&
                                <div
                                    data-aos="fade-zoom-in"
                                    data-aos-easing="linear"
                                    data-aos-duration="2000"
                                    className='max-w-2xl'
                                >
                                    <img src={bookHotel} alt='bookHotel' />
                                </div>
                            }
                        </CardMedia>
                    </Card>
                </Box>

                {/* Recent Blogs */}
                <RecentBlogs blogDetails={getBlogs()} />

                {/* Recent Tweets */}
                <Box className='w-full border-y-2 border-[#6b38a5] border-dashed'>
                    <div className='flex justify-center text-start mt-8 w-full' id='recent-tweets'>
                        <Typography variant='h4' className='w-full max-w-7xl px-5 md:px-8' sx={{ color: 'primary.yorisWhite' }}>Recent Tweets</Typography>
                    </div>
                    <RecentTweets tweetDetails={getTweets(2)} />
                </Box>

                {/* FAQs */}
                <Box className='flex flex-col items-center text-start py-8 md:py-12 w-full'
                    id='faqs' sx={{ backgroundColor: '#15130A' }}
                >
                    <Typography
                        variant='h4' className='w-full max-w-7xl px-5 md:px-8'
                        sx={{ color: 'primary.yorisWhite', fontFamily: 'Sarala' }}>
                        FAQs
                    </Typography>
                    <Box className='w-full max-w-6xl'><FAQs /></Box>
                </Box>
            </Box>
        </Box>
    )
};

export default Home;